import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import {
  getHistoricoInventarioHilaza,
  getInventarioMensualHilaza,
} from "../../../API/Inventarios/BodegaMateriales/BodegaMaterialesRequests";
import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import Card from "../../../Components/Card/Card";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { TabPanel, TabView } from "primereact/tabview";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";
import ModalIngresosPromedio from "../BodegaHilaza/ModalIngresosPromedio";

const InventarioMensualHilazaScreen = () => {
  const { userAuth } = useContext(AuthContext);
  const { config } = useContext(ConfigContext);
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [data, setData] = useState([]);
  const [dataHistorico, setDataHistorico] = useState([]);
  const [date, setDate] = useState(new Date());
  const [CodigoProducto, setCodigoProducto] = useState(null);
  const [IdProducto, setIdProducto] = useState(null);
  const [dialogPromedio, setDialogPromedio] = useState(false);

  const obtenerInformacion = async () => {
    setLoading(true);
    setMostrarDetalle(false);
    let tempoResumen = [];
    if (activeIndex === 0) {
      tempoResumen = await getInventarioMensualHilaza();
      setData(tempoResumen);
    } else if (activeIndex === 1) {
      let year = date.getFullYear();
      let mes = date.getMonth() + 1;
      tempoResumen = await getHistoricoInventarioHilaza(mes, year);
      setDataHistorico(tempoResumen);
    }
    setLoading(false);
  };

  const habilitarOcultos = () => {
    setMostrarDetalle((prev) => !prev);
  };

  const hideDialog = () => {
    setDialogPromedio(false);
    setIdProducto(null);
  };

  //Datos Inventario
  const columns = [
    //Producto
    {
      header: "PRODUCTO",
      headerName: "PRODUCTO",
      children: [
        {
          field: "Promedio",
          header: "Promedio",
          headerEn: "",
          className: "Xsmall",
          hidden: userAuth.IdRol === 1,
        },

        {
          field: "CodigoInv",
          header: "IdIngreso",
          headerEn: "",
          className: "small",
          frozen: true,
          alignFrozen: "left",
          onCellDoubleClicked: ({ data }) => {
            if (data.CodigoInv) {
              if (data.Promedio === 1) {
                setIdProducto(data?.IdProductoSuministro);
                setCodigoProducto(data.Codigo);
                setDialogPromedio(true);
              }
            }
          },
        },

        {
          field: "Categoria",
          header: "Categoria",
          className: "small",
          filter: true,
          sort: "asc",
          frozen: true,
          alignFrozen: "left",
        },
        {
          field: "Codigo",
          header: "Codigo ",
          headerEn: "Code",
          className: "small",
          filter: true,
          frozen: true,
          alignFrozen: "left",
          onCellDoubleClicked: ({ data }) => {
            if (data.CodigoInv) {
              if (data.Promedio === 1) {
                setIdProducto(data?.IdProductoSuministro);
                setCodigoProducto(data.Codigo);
                setDialogPromedio(true);
              }
            }
          },
        },
        {
          field: "NombreProducto",
          header: "NombreProducto",
          headerEn: "Product Name",
          className: "XXXlarge",
          filter: true,
          frozen: true,
          alignFrozen: "left",
          Sumary: "count",
        },
        {
          header: "IdYarn",
          headerEn: "",
          field: "IdYarn",
          className: "small",
          hidden: userAuth.IdRol === 1,
        },
        {
          field: "Antiguedad",
          header: "Antiguedad",
          headerEn: "Antiguedad",
          className: "small",
          Format: "Center",
        },
        {
          field: "EstadoAntiguedad",
          header: "Estado Antiguedad",
          headerEn: "Estado Antiguedad",
          className: "medium",
        },

        {
          field: "Uso",
          header: "Uso",
          className: "Xsmall",
          filter: true,
        },
        {
          field: "CategoriaIngreso",
          header: "Usable",
          className: "Xsmall",
          filter: true,
        },
        {
          field: "Lote",
          header: "Lote Hilaza",
          className: "small",
          filter: true,
        },
      ],
    },

    //Inicial
    {
      header: "Inicial",
      headerName: "Inicial",
      children: [
        {
          field: "Inicial",
          header: "Inicial (kg)",
          headerEn: "Initial (kg)",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "Xsmall",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "Xsmall",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "InMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Compras
    {
      header: "COMPRAS",
      headerName: "COMPRAS",
      children: [
        {
          field: "Compras",
          header: "Ingresos",
          headerEn: "Incomes",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "Xsmall",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "Xsmall",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Ingresos
    {
      header: "INGRESOS",
      headerName: "INGRESOS",
      children: [
        {
          field: "Ingresos",
          header: "Ingresos",
          headerEn: "Incomes",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "Xsmall",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "Xsmall",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Devoluciones Proveedor
    {
      header: "DEVOLUCIONES PROVEEDOR",
      headerName: "DEVOLUCIONES PROVEEDOR",
      children: [
        {
          field: "DevP",
          header: "Devoluciones",
          headerEn: "Returns",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IDevPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "Xsmall",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "Xsmall",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Salidas
    {
      header: "SALIDAS",
      headerName: "SALIDAS",
      children: [
        {
          field: "Salidas",
          header: "Salidas",
          headerEn: "Outputs",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "small",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: true,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "small",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Salidas Reales
    {
      header: "SALIDAS REALES",
      headerName: "SALIDAS REALES",
      children: [
        {
          field: "SalidasReal",
          header: "Salidas",
          headerEn: "Outputs",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SRealPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SRealMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SRealPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SRealMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Devoluciones Internas
    {
      header: "DEVOLUCIONES INTERNAS",
      headerName: "DEVOLUCIONES INTERNAS",
      children: [
        {
          field: "Dev",
          header: "Devoluciones",
          headerEn: "Returns",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Inventario
    {
      header: "INVENTARIO",
      headerName: "INVENTARIO",
      children: [
        {
          field: "Inventario",
          header: "Inventario",
          headerEn: "Inventario",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          // hidden: mostrarDetalle
        },
        {
          field: "PrecioL",
          header: "Precio L",
          headerEn: "Precio L",
          className: "small",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // hidden: mostrarDetalle
        },
        {
          field: "MontoL",
          header: "Monto L",
          headerEn: "Monto L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          // hidden: mostrarDetalle
        },

        {
          field: "Precio",
          header: "Precio",
          headerEn: "Precio",
          className: "X=small",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
          // hidden: mostrarDetalle
        },
        {
          field: "Monto",
          header: "Monto",
          headerEn: "Monto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
          // hidden: mostrarDetalle
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: data,
    loading: loading,
  };

  //Datos Inventario Historicos
  const columns2 = [
    //Producto
    {
      header: "PRODUCTO",
      headerName: "PRODUCTO",

      children: [
        {
          header: "IdDetalle",
          headerEn: "",
          field: "IdDetalle",
          className: "",
          frozen: true,
          alignFrozen: "left",
        },

        {
          field: "Categoria",
          header: "Categoria",
          className: "Xsmall",
          filter: true,
          sort: "asc",
          // frozen: true,
          // alignFrozen: 'left',
        },
        {
          field: "Uso",
          header: "Uso",
          className: "Xsmall",
          filter: true,
        },
        {
          field: "CategoriaIngreso",
          header: "Usable",
          className: "Xsmall",
          filter: true,
        },
        {
          field: "Codigo",
          header: "Codigo ",
          headerEn: "Code",
          className: "medium",
          filter: true,
          frozen: true,
          alignFrozen: "left",
        },
        {
          field: "NombreProducto",
          header: "NombreProducto",
          headerEn: "Product Name",
          className: "XXXlarge",
          filter: true,
          // frozen: true,
          // alignFrozen: 'left',
          Sumary: "count",
        },

        {
          field: "Lote",
          header: "Lote Hilaza",
          className: "small",
          filter: true,
        },
      ],
    },

    {
      header: "Antigüedad",
      headerName: "Antigüedad",
      children: [
        {
          field: "Antiguedad",
          header: "Antigüedad",
          headerEn: "Antigüedad",
          className: "small",
          Format: "Center",
        },
        {
          field: "EstadoAntiguedad",
          header: "Estado Antigüedad",
          headerEn: "Estado Antigüedad",
          className: "small",
          Format: "Center",
        },
      ],
    },

    //Inicial
    {
      header: "INICIAL",
      headerName: "INICIAL",
      children: [
        {
          field: "Inicial",
          header: "Inicial",
          headerEn: "Inicial",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
        },
        {
          field: "InPrecioL",
          header: "Precio L",
          headerEn: "InPrecio",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          field: "InMontoL",
          header: "Monto L",
          headerEn: "InMonto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
        },
        {
          field: "InPrecio",
          header: "Precio $",
          headerEn: "InPrecio",
          className: "Xsmall",
          Format: "Currency",
        },
        {
          field: "InMonto",
          header: "Monto $",
          headerEn: "InMonto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
        },
      ],
    },

    //Ingresos
    {
      header: "INGRESOS",
      headerName: "INGRESOS",
      children: [
        {
          field: "Ingresos",
          header: "Ingresos",
          headerEn: "Ingresos",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IPrecioL",
          header: "Precio L",
          headerEn: "IPrecio",
          className: "Xsmall",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IMontoL",
          header: "Monto L",
          headerEn: "IMonto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IPrecio",
          header: "Precio $",
          headerEn: "IPrecio",
          className: "Xsmall",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "IMonto",
          header: "Monto $",
          headerEn: "IMonto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Compras
    {
      header: "Compras",
      headerName: "Compras",
      children: [
        {
          field: "Compras",
          header: "Compras",
          headerEn: "Compras",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComPrecioL",
          header: "Precio L",
          headerEn: "IPrecio",
          className: "Xsmall",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComMontoL",
          header: "Monto L",
          headerEn: "IMonto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComPrecio",
          header: "Precio $",
          headerEn: "IPrecio",
          className: "Xsmall",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "ComMonto",
          header: "Monto $",
          headerEn: "IMonto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Salidas
    {
      header: "SALIDAS",
      headerName: "SALIDAS",
      children: [
        {
          field: "Salidas",
          header: "Salidas",
          headerEn: "Salidas",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SPrecioL",
          header: "Precio L",
          headerEn: "SPrecio",
          className: "small",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SMontoL",
          header: "Monto L",
          headerEn: "SMonto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SPrecio",
          header: "Precio $",
          headerEn: "SPrecio",
          className: "small",
          Format: "Currency",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SMonto",
          header: "Monto $",
          headerEn: "SMonto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: !mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Salidas Reales
    {
      header: "SALIDAS REALES",
      headerName: "SALIDAS REALES",
      children: [
        {
          field: "SalidasReal",
          header: "Salidas",
          headerEn: "Outputs",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SRealPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SRealMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SRealPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "SRealMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "Dev",
          header: "Devoluciones",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Devoluciones Internas
    {
      header: "DEVOLUCIONES INTERNAS",
      headerName: "DEVOLUCIONES INTERNAS",
      children: [
        {
          field: "Dev",
          header: "Devoluciones",
          headerEn: "Returns",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Devoluciones Proveedor
    {
      header: "DEVOLUCIONES PROVEEDOR",
      headerName: "DEVOLUCIONES PROVEEDOR",
      children: [
        {
          field: "DevP",
          header: "Devoluciones",
          headerEn: "Returns",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPPrecio",
          header: "Precio $",
          headerEn: "Price $",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPMonto",
          header: "Monto $",
          headerEn: "Amount $",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPPrecioL",
          header: "Precio L",
          headerEn: "Price L",
          className: "small",
          Format: "Currency",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
        {
          field: "DevPMontoL",
          header: "Monto L",
          headerEn: "Amount L",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          hidden: mostrarDetalle,
          editable: userAuth.IdRol === 1,
        },
      ],
    },

    //Inventario
    {
      header: "INVENTARIO",
      headerName: "INVENTARIO",
      children: [
        {
          field: "Inventario",
          header: "Inventario",
          headerEn: "Inventario",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "PrecioL",
          header: "Precio L",
          headerEn: "Precio",
          className: "Xsmall",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "MontoL",
          header: "Monto L",
          headerEn: "Monto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "Precio",
          header: "Precio $",
          headerEn: "Precio",
          className: "Xsmall",
          Format: "Currency",
          editable: userAuth.IdRol === 1,
        },
        {
          field: "Monto",
          header: "Monto $",
          headerEn: "Monto",
          className: "small",
          Format: "Currency",
          Sumary: "sum",
          editable: userAuth.IdRol === 1,
        },
      ],
    },
  ];

  const table2 = {
    Columns: columns2,
    Data: dataHistorico,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "BodegaHilaza", config.language));
    obtenerInformacion();
  }, [activeIndex, date]);

  return (
    <div className="mt-2">
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "BodegaHilaza", config.language)}</h3>
            {activeIndex === 1 && (
              <Calendar
                value={date}
                onChange={(e) => setDate(e.value)}
                view="month"
                dateFormat="mm/yy"
                showIcon
              />
            )}
            <Button
              icon="pi pi-sync"
              className="mx-1"
              onClick={obtenerInformacion}
            />
            <Button icon="pi pi-eye" onClick={habilitarOcultos} />
          </div>
        }
        contenido={
          <div
            className="pt-4"
            style={{ height: "90vh" }}
            id="IngresosCombustibles"
          >
            <TabView
              className="col-12 homeTabView"
              activeIndex={activeIndex}
              onTabChange={(e) => setActiveIndex(e.index)}
            >
              <TabPanel header="Inventario Mensual">
                <div
                  className="pt-4"
                  style={{ height: "84vh" }}
                  id="ResumenInventario"
                >
                  <AgGrid table={table} />
                </div>
              </TabPanel>
              <TabPanel header="Historico">
                <div className="pt-4" style={{ height: "84vh" }} id="Historico">
                  <AgGrid table={table2} />
                </div>
              </TabPanel>
            </TabView>
          </div>
        }
      />

      <ModalIngresosPromedio
        dialogPromedio={dialogPromedio}
        hideDialogPromedio={hideDialog}
        IdProducto={IdProducto}
        IdReferencia={5}
        CodigoProducto={CodigoProducto}
      />
    </div>
  );
};

export default InventarioMensualHilazaScreen;
